// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2Un4S","text":"SelectPayment_text__1bmJw","title":"SelectPayment_title__24uC7","btn":"SelectPayment_btn__1IrJk"};